/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};


(function () {
  'use strict';

  /**
   * Хелпер для форматирования строк.
   */
  app.helpers.StringHelper = {
    /**
     * Убираем пробелы и лишние символы из поискового запроса.
     * @param query
     * @returns {string}
     */
    normalizeQuery: function (query) {
      return String(query)
        .trim()
        .replace(/^&|\?/g, '')
        .toLowerCase();
    },

    /**
     * Конкатенация названий города и региона
     * @param {object} settlement Выбранный город.
     * @returns {string} Название города и региона
     */
    getSettlementString: function(settlement) {
      var output = '';
      if (settlement) {
        output += settlement.get('name');
        if (settlement.get('region')) {
          output += ' (' + settlement.get('region') + ')';
        }
      }

      return output;
    },

    /**
     * @typedef {Object} StringPartData Объект c данными части строки.
     * @property {string} text Текстовая часть.
     * @property {string|null|undefined} href Url, если является ссылкой.
     */

    /**
     * Преобразует строку с ссылками, хэштегами в массив данных.
     * @param {string} content Обрабатываемая строка.
     * @return {Array<StringPartData>} Массив с данными.
     */
    prepareStringWithLinks: function (content) {
      var simaURLregExp = /(\S*sima-land\.ru\S*)/g;
      var linkRegExp = /(<a\s.*?>.*?<\/a>)/ig;
      var hashtagRegExp = /(#[A-zА-Яа-яЁё0-9-]+)/m;

      var allRegExp = /(<a\s.*?>.*?<\/a>)|(\S*sima-land\.ru\S*)|(#[A-zА-Яа-яЁё0-9-]+)/igm;
      var separator = '__%separator%__';

      return content
        ? String(content)
          .replace(allRegExp, function (value) {
            return separator + value + separator;
          })
          .split(separator)
          .filter(Boolean)
          .map(function (part) {
            var result = { text: part };
            if (linkRegExp.test(part)) {
              result = this.prepareLink(part);
            } else if (simaURLregExp.test(part)) {
              result.href = part;
            } else if (hashtagRegExp.test(part)) {
              result = this.prepareHashtag(part);
            }
            return result;
          }.bind(this))
        : [{ text: '' }];
    },

    /**
     * Преобразует хэштег в объект с данными.
     * @param {string} hashtag Строка вида '#test'.
     * @return {StringPartData} Объект с данными.
     */
    prepareHashtag: function (hashtag) {
      var result = { text: hashtag };
      var sidPattern = /(#([0-9]{6,}))/;
      if (hashtag && app.isHashtagToSearchEnabled) {
        var linkQuery = hashtag;
        var linkText = hashtag;
        var hasSid = hashtag.match(sidPattern);
        if (hasSid) {
          linkQuery = hasSid[2];
        }
        result = {
          href: app.entryScriptName + '/search/?q=' + encodeURIComponent(linkQuery),
          text: linkText
        };
      }
      return result;
    },

    /**
     * Преобразует ссылку в объект с данными.
     * @param {string} link Строка вида '<a href="#">test</a>'.
     * @return {StringPartData} Объект с данными.
     */
    prepareLink: function (link) {
      var linkHref = link.match(/href="(.*)"/),
        linkText = link.match(/>(.*)</);
      return {
        href: linkHref ? linkHref[1] : null,
        text: linkText ?  linkText[1] : ''
      };
    },

    /**
     * Возвращает очищенный от HTML-тегов текст.
     * @param {string} textWithHtml Текст с HTML-тегами.
     * @return {string} Очищенный от тегов текст.
     */
  stripHtmlTags: function (textWithHtml) {
      var div = document.createElement('div');
      div.innerHTML = textWithHtml;
      return div.textContent || div.innerText || '';
    }
  };
})();


}.call(window));